<template>
  <div v-if="search.result">
    <slot :totalItems="compAllResults" />

    <template v-if="searchable">
      <FormTextInput
        v-if="compTotalHiddenResults"
        name="search-facet"
        type="search"
        v-model="searchQuery"
        @captureEnterKeyPress="() => {}"
        class="search-input"
        targetClass="w-full"
        :placeholder="searchPlaceholder"
        :iconPrefix="faSearch"
      />

      <div v-if="searchQuery && !compVisibleResults.length">
        No results.
        <UtilTextLink @click="searchQuery = ''" class="text-brand">Reset</UtilTextLink>
      </div>
    </template>

    <div v-for="facet in compVisibleResults" :key="facet.name" class="flex items-center mb-1">
      <FormCheckbox
        @change="$store.dispatch(`${moduleName}/toggleFacet`, { key: facetKey, value: facet.name })"
        v-model="facet.isRefined"
        :trueValue="true"
        :name="facet.name"
        :label="hierarchical ? facet.name.split(' > ')[1] : facet.name"
        class="mb-0 clamp-1"
      />

      <span v-if="facet.count" class="text-sm text-gray">{{ facet.count.toLocaleString() }}</span>
    </div>

    <UtilTextLink
      v-if="compTotalHiddenResults && !isViewingAll && !searchQuery"
      @click="viewAll()"
      class="no-underline"
    >
      <span class="underline">View {{ compTotalHiddenResults }} more</span>
      <FontAwesomeIcon :icon="faCaretDown" class="ml-1" />
    </UtilTextLink>
  </div>
</template>

<script>
  import {faSearch} from '@fortawesome/pro-regular-svg-icons'
  import {faCaretDown} from '@fortawesome/pro-solid-svg-icons'
  import FormCheckbox from '@/components/forms/elements/FormCheckbox'
  import FormTextInput from '@/components/forms/elements/FormTextInput'
  import UtilTextLink from '@/components/utils/UtilTextLink'

  export default {
  name: 'UtilSearchFacet',
  components: {
    FormCheckbox,
    FormTextInput,
    UtilTextLink
  },
  props: {
    search: {
      type: Object,
      required: true
    },
    facetKey: {
      type: String,
      required: true
    },
    moduleName: {
      type: String,
      default: 'search'
    },
    maxVisible: {
      type: Number,
      default: 10
    },
    searchable: Boolean,
    searchPlaceholder: String,
    hierarchical: Boolean
  },
  data() {
    return {
      searchQuery: '',
      isViewingAll: false,
      faSearch,
      faCaretDown
    }
  },
  computed: {
    compAllResults() {
      if (!this.search.result) {
        return []
      }

      return this.search.result.getFacetValues(this.facetKey)
    },

    compVisibleResults() {
      if (this.searchQuery) {
        return this.compAllResults.filter(facet => facet.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
      }

      if (this.isViewingAll) {
        return this.compAllResults
      }

      return this.compAllResults.slice(0, this.maxVisible)
    },

    compTotalHiddenResults() {
      if (this.compAllResults.length < this.maxVisible) {
        return 0
      }

      return this.compAllResults.length - this.maxVisible
    }
  },
  methods: {
    searchForItems() {},

    viewAll() {
      this.isViewingAll = true

      this.$analytics.addEvent({
        category: 'search',
        action: 'Clicked view more on filter list',
        label: this.facetKey
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-input {
  max-width: 180px;
}
</style>
